'use strict';

/**
 * Back to Top Button
 *
 * Handles:
 * - Floating circular back-to-top button (.js24BackToTop)
 * - Footer "zurück zum Seitenanfang" link (.c24-footer-jumptotop)
 *
 * Note: This page scrolls on document.body (not document.documentElement),
 * so we need to check body.scrollTop for scroll position detection.
 */
(function() {
    const LAYOUT_CENTER_OFFSET = 730;
    const DISPLAY_LIMIT = 150;

    /**
     * Get current scroll position from all possible scroll containers
     */
    function getScrollTop() {
        return window.scrollY ||
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
    }

    /**
     * Handle scroll - show/hide button based on scroll position
     */
    function handleScroll() {
        const btn = document.querySelector('.js24BackToTop');
        if (!btn) return;

        const scrollTop = getScrollTop();

        if (scrollTop > DISPLAY_LIMIT) {
            btn.classList.add('js24BackToTopShow');
        } else {
            btn.classList.remove('js24BackToTopShow');
        }

        // Dynamic positioning
        const posRight = window.innerWidth / 2 - LAYOUT_CENTER_OFFSET - 48;
        btn.style.right = Math.max(posRight, 20) + 'px';
    }

    /**
     * Scroll to top - handles both window and body scroll containers
     */
    function scrollToTop(e) {
        if (e) e.preventDefault();
        // Try all scroll methods to handle different scroll containers
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }

    /**
     * Initialize all handlers
     */
    function init() {
        // Back-to-top floating button
        const btn = document.querySelector('.js24BackToTop');

        if (btn) {
            // Standard scroll listeners
            window.addEventListener('scroll', handleScroll, { passive: true });
            document.addEventListener('scroll', handleScroll, { passive: true });
            window.addEventListener('resize', handleScroll);
            btn.addEventListener('click', scrollToTop);
            handleScroll(); // Initial state

            // Fallback: poll for scroll position changes
            // This handles smooth scrolling and body scroll containers
            let lastScrollTop = 0;
            setInterval(function() {
                const currentScrollTop = getScrollTop();
                if (currentScrollTop !== lastScrollTop) {
                    lastScrollTop = currentScrollTop;
                    handleScroll();
                }
            }, 200);
        }

        // Footer link
        const footerLink = document.querySelector('.c24-footer-jumptotop');
        if (footerLink) {
            footerLink.style.cursor = 'pointer';
            footerLink.addEventListener('click', scrollToTop);
        }

        // Register with footerManager if available
        if (window.footerManager && btn) {
            window.footerManager.registerElement('.js24BackToTop', 30, false, false);
        }
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
